export default __webpack_public_path__ + "static/media/EM0333.34I-41681_-24960_0.861ab7fd.jpg";